module.exports = __webpack_public_path__ + "static/media/buttonsounds11.4c8e655b.wav";